export const SET_POST: string = 'SET_POST';
export const SET_POST_ERROR: string = 'SET_POST_ERROR';
export const RESET_POST: string = 'RESET_POST';
